import React from "react";
import SelectMenu from "../../controls/SelectMenu";
import Input from "../../controls/Input";
import TextArea from "../../controls/TextArea";

export default function PurchaseOrderHeaderForm({
  purchaseOrder,
  supplierOptions,
  locationOptions,
  onSupplierChange,
  onLocationChange,
  setPurchaseOrderField,
  compact = false,
}: any) {
  const supplierValue =
    supplierOptions.find((o: any) => o.value === purchaseOrder.supplier_id) ||
    null;
  const locationValue =
    locationOptions.find(
      (o: any) => o.value === purchaseOrder.location?.value,
    ) ||
    purchaseOrder.location ||
    null;

  return (
    <section
      className={
        compact
          ? "flex h-full flex-col rounded-2xl border border-[#E2E8F0] bg-white p-4 shadow-sm"
          : "rounded-2xl border border-[#E2E8F0] bg-white p-5 shadow-sm"
      }
    >
      <h2
        className={
          compact
            ? "text-sm font-semibold text-[#0F172A]"
            : "text-base font-semibold text-[#0F172A]"
        }
      >
        Supplier &amp; delivery
      </h2>
      {!compact && (
        <p className="mt-1 text-sm text-[#64748B]">
          Select the vendor and when materials are expected.
        </p>
      )}

      <div
        className={
          compact
            ? "mt-3 flex flex-1 flex-col gap-3"
            : "mt-5 flex flex-col gap-4"
        }
      >
        <div className="grid gap-3 sm:grid-cols-2">
          <div className="sm:col-span-2">
            <SelectMenu
              title="Supplier"
              name="supplier_id"
              options={supplierOptions}
              value={supplierValue}
              handleInputChange={(e: any) => onSupplierChange(e.target.value)}
              isClearable
              placeholder="Select supplier…"
            />
          </div>
          <Input
            label="PO date"
            labelOn
            name="order_date"
            type="date"
            value={purchaseOrder.order_date}
            onChange={(e: any) =>
              setPurchaseOrderField("order_date", e.target.value)
            }
          />
          <Input
            label="Expected delivery date"
            labelOn
            name="expected_delivery_date"
            type="date"
            value={purchaseOrder.expected_delivery_date}
            onChange={(e: any) =>
              setPurchaseOrderField("expected_delivery_date", e.target.value)
            }
          />
          <div className="sm:col-span-2">
            <SelectMenu
              title="Location"
              name="location"
              options={locationOptions}
              value={locationValue}
              handleInputChange={(e: any) => onLocationChange(e.target.value)}
              isClearable
              placeholder="Select location…"
            />
          </div>
        </div>

        <TextArea
          label="Notes"
          labelOn
          name="notes"
          rows={3}
          parentClass="w-full"
          className="mt-1 block w-full max-w-none rounded-md border border-gray-300 px-3 py-2 text-sm shadow-sm focus:border-sky-500 focus:outline-none focus:ring-sky-500"
          value={purchaseOrder.notes}
          onChange={(e: any) => setPurchaseOrderField("notes", e.target.value)}
        />
      </div>
    </section>
  );
}
